<nz-form-item>
  <nz-form-control [nzErrorTip]="phoneError">
    <div class="profile-label-row">
      <label class="label-text required" for="profilePhoneNumber">Mobile number</label>
      <a class="profile-verify-link" *ngIf="_uiCanSend" (click)="send()">Verify number</a>
      <span class="profile-verify-link" *ngIf="sending"><span nz-icon nzType="loading"></span>Sending code…</span>
      <span class="phone-verified-text" *ngIf="_uiVerified">Verified</span>
    </div>
    <nz-input-group>
      <input id="profilePhoneNumber" class="input-group" nz-input [formControl]="control" (paste)="_cs.checkNumbers($event)"
        (keypress)="_cs.checkNumbers($event)" mask="(000) 000-0000"></nz-input-group>
    <div class="ant-form-item-explain-error phone-change-message" *ngIf="sendError">{{ sendError }}</div>
    <div class="phone-change-hint" *ngIf="_uiNeedsVerify">Verify your new mobile number before updating your profile.</div>
    <ng-template #phoneError let-control>
      <ng-container *ngIf="control.hasError('required')">Please enter mobile number
      </ng-container>
      <ng-container *ngIf="control.hasError('pattern')">
        Mobile number must contain at least 10 characters
      </ng-container>
    </ng-template>
  </nz-form-control>
</nz-form-item>

<nz-form-item *ngIf="_uiCodeSent">
  <nz-form-control>
    <label class="label-text required" for="profilePhoneCode">Verification code</label>
    <div class="phone-code-entry">
      <input id="profilePhoneCode" class="input-group" nz-input [formControl]="codeControl" maxlength="6"
        inputmode="numeric" autocomplete="one-time-code" placeholder="6-digit code" (keypress)="_cs.checkNumbers($event)">
      <button nz-button nzType="primary" type="button" class="medium-btn small-btn" [nzLoading]="verifying"
        [disabled]="_uiCodeIncomplete" (click)="confirm()">Confirm</button>
    </div>
    <div class="ant-form-item-explain-error phone-change-message" *ngIf="codeError">{{ codeError }}</div>
    <div class="phone-change-hint">
      <span>Code sent to {{ maskedPhone }}.</span>
      <span *ngIf="_uiCooldown">Resend code in {{ cooldownSeconds }}s</span>
      <a class="profile-verify-link" *ngIf="!_uiCooldown" (click)="resend()">Resend code</a>
      <a class="profile-verify-link" (click)="changeNumber()">Change number</a>
    </div>
  </nz-form-control>
</nz-form-item>
